import { isEmpty } from "lodash";
import { isNonNullable } from "../utils/typeGuards";
import { FieldsResponse } from "./api/karl-farm/useFields";

export const useFieldGroups = (fieldsData?: FieldsResponse) => {
  const fieldGroupsWithDuplicates = fieldsData?.data?.fields
    .map((field) => {
      return field.custom_attributes?.app_properties?.farm_name; // farm_name hasn't been renamed to field_group in the backend yet
    })
    .filter(isNonNullable)
    .filter((string) => !isEmpty(string));
  const fieldGroups = [...new Set(fieldGroupsWithDuplicates)].sort((a, b) =>
    a.localeCompare(b)
  );
  return fieldGroups;
};
